import { Button } from "antd";
import {
  HeaderWrapper,
  UserDetailsWrapper,
} from "../../pages/UserDetail/UserInfoStyled";
import UserData from "./UserData";
import EditUserInfoModal from "../EditUserInfoModal/EditUserInfoModal";
import { useState } from "react";
import { IUserDetails } from "../../interface/UserDetail";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { CONFIRM_MODAL_MESSAGES } from "../../utils/constants/messages";
import { isCurrentUser, isSuperAdminUser } from "../../utils/utils";
import EditCustomerInfoModal from "../../pages/CustomerDetails/EditCustomerInfoModal/EditCustomerInfoModal";
import CustomerData from "./CustomerData";

const UserInfoSection = ({
  type = "User",
  data,
  onDelete,
}: {
  type?: string;
  data: IUserDetails;
  onDelete?: Function;
}) => {
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const isSuperAdmin = isSuperAdminUser();

  return (
    <>
      <HeaderWrapper>
        <p className="user-info-header">
          <span className="title">{type} Info</span>
          <span className="sub">
            View/Edit {type.toLowerCase()} information
          </span>
        </p>
        <div className="action-button-wrapper">
          {isSuperAdmin && (
            <Button
              className={
                isCurrentUser(data.id) ? "edit-btn disabled" : "edit-btn"
              }
              size="large"
              onClick={() => setShowEditUserModal(true)}
            >
              Edit Info
            </Button>
          )}
          {isSuperAdmin && (
            <Button
              danger
              className={
                isCurrentUser(data.id) ? "del-btn disabled" : "del-btn"
              }
              onClick={() => setShowDeleteModal(true)}
            >
              Delete {type.toLowerCase()}
            </Button>
          )}
        </div>
      </HeaderWrapper>
      <UserDetailsWrapper>
        {type === "Customer" ? (
          <CustomerData data={data} />
        ) : (
          <UserData type={type} data={data} />
        )}
      </UserDetailsWrapper>
      {type === "Customer" ? (
        <EditCustomerInfoModal
          isOpen={showEditUserModal}
          closeModal={() => setShowEditUserModal(false)}
          data={data}
        />
      ) : (
        <EditUserInfoModal
          isOpen={showEditUserModal}
          closeModal={() => setShowEditUserModal(false)}
          type={type}
          data={data}
        />
      )}
      <ConfirmationModal
        open={showDeleteModal}
        onCancel={() => setShowDeleteModal(false)}
        okText="Yes, Delete"
        onOk={() => onDelete && onDelete()}
        title={
          type === "User"
            ? CONFIRM_MODAL_MESSAGES.DELETE_USER.title
            : CONFIRM_MODAL_MESSAGES.DELETE_CUSTOMER.title
        }
        subText={
          type === "User"
            ? CONFIRM_MODAL_MESSAGES.DELETE_USER.description
            : CONFIRM_MODAL_MESSAGES.DELETE_CUSTOMER.description
        }
        customClass="error-btn"
      />
    </>
  );
};

export default UserInfoSection;
